import { useCallback, useEffect, useState } from "react";
import DataTable from "../datatable/DataTable";
import { Link } from "react-router-dom";
import "../blogs/admin_blog.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const testimonialDeleteEndpoint = ApiEndpoints.VideoTestimonial.testimonialDelete;
const testimonialListEndpoint = ApiEndpoints.VideoTestimonial.testimonialView;
const testimonialEditPath = "edit-testimonial";
const tableHeader = ["URL"];
const tbody = ["url"];

export default function TestimonialList() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const dataFetch = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", testimonialListEndpoint);
      const result = response.video_testimonials;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  }, []);


  useEffect(() => {
    dataFetch();
  }, [dataFetch]);


  const handleDelete = useCallback(
    async (testimonial_id) => {
      const payload = { "id" :testimonial_id};
      try {
        await ApiRequest("POST", testimonialDeleteEndpoint, payload);
        toast.success("Testimonial is Deleted Successfully")
        dataFetch();
        navigate("/admin")
      } catch (error) {
        console.error(error);
      }
    },
    [dataFetch]
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Video Testimonials</h5>
      </div>
      <div className="add-blog-section">
        <Link className="default-btn" to="/admin/add-testimonial">
          add Testimonials
        </Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={testimonialEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
